module.exports = __webpack_public_path__ + "static/img/13.c00411d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/13.png
// module id = xy2Z
// module chunks = 0